import { useQuery } from '@tanstack/react-query'
import { readBlock as readBlockRequest } from './requests/read'
import { type BlockResponse } from './types'
import { readBlock } from '.'

type UseReadBlockParams = {
  blockId: string
  workspaceUuid: string
  enabled?: boolean
}

type UseReadBlockOptions<T = BlockResponse> = UseReadBlockParams & {
  select?: (data: BlockResponse) => T
}

export const useReadBlock = <T = BlockResponse>({
  blockId,
  workspaceUuid,
  enabled,
  select,
}: UseReadBlockOptions<T>) => {
  return useQuery({
    enabled,
    queryKey: readBlock.queryKey({
      workspaceUuid,
      resourceId: blockId,
      queryParams: null,
    }),
    queryFn: () =>
      readBlockRequest({
        params: {
          path: {
            block_id: blockId,
            workspace_id: workspaceUuid,
          },
        },
      }),
    select,
  })
}
